import { render, staticRenderFns } from "./events-statistics.vue?vue&type=template&id=33fc2a3f&"
import script from "./events-statistics.vue?vue&type=script&lang=ts&"
export * from "./events-statistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports